// ─────────────────────────────────────────────────────────────
// Todos los textos de la landing. Edita aquí y se actualiza la página.
// En los títulos: title + highlight (dorado) + after.
// Los "icon" son nombres de íconos (ver utils/icons.ts).
// Idioma: español neutro latino (tuteo, sin voseo).
// ─────────────────────────────────────────────────────────────

export const CHECKOUT_URL = "https://atlas-quirurgico.impultienda.ar/checkout";

// Pixel "Pixel Atlas Quirurgico" (CUENTA 18). Déjalo vacío para no cargar el Pixel de Meta.
export const META_PIXEL_ID = "2094382914526608";

export const pricing = {
  original: "USD 97",
  current: "USD 19",
  currencyNote:
    "💱 Pagas en la moneda de tu país: el checkout te muestra el precio convertido automáticamente.",
};

// Mockup de la caja 6 en 1 (PNG con fondo transparente, texto en español neutro)
export const mockup = {
  src: "https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/ebook-images/77bfeec9-5a25-4920-82db-de45910b051b/product-uploads/mcp_ff9d58da-f4bb-4a6d-99a5-2d6f3cf78676_1792604127282.png",
  alt: "Caja del Atlas Visual de Instrumental Quirúrgico, sistema completo 6 en 1",
};

export const product = {
  name: "🩺 Atlas Visual de Instrumental Quirúrgico™",
  tagline: "El sistema completo de estudio visual para instrumentación quirúrgica",
  verbs: "Reconocer • Nombrar • Comparar • Armar • Anticipar • Repasar",
};

// HERO
export const hero = {
  title: "EL SISTEMA COMPLETO DE ESTUDIO VISUAL PARA ",
  highlight: "INSTRUMENTACIÓN QUIRÚRGICA",
  text: "Deja de saltar entre apuntes, fotocopias e imágenes sueltas cada vez que necesitas reconocer un instrumento. Usa referencias visuales organizadas, fichas con ilustraciones y herramientas de comparación para identificar el instrumental, entender para qué sirve y pasarlo con más seguridad.",
  punchline: "OBSERVA. COMPARA. RECONOCE CON SEGURIDAD.",
  cta: "🩺 ¡SÍ! QUIERO EL SISTEMA COMPLETO",
  // El botón del hero baja a la oferta (no va al checkout)
  ctaHref: "#oferta-precio",
  finePrint: "CONSIGUE HOY EL ATLAS VISUAL DE INSTRUMENTAL QUIRÚRGICO™",
  pills: [
    { icon: "layers", label: "6 EN 1" },
    { icon: "zap", label: "ACCESO INMEDIATO" },
    { icon: "shield", label: "GARANTÍA 7 DÍAS" },
  ],
};

export const pain = {
  title: "DEJA DE INTENTAR APRENDER EL INSTRUMENTAL ",
  highlight: "SOLO CON TEXTO",
  text: "¿Las pinzas te parecen todas iguales? ¿Las cajas cambian de una especialidad a otra? Kelly, Crile, Kocher, Allis, Babcock, Metzenbaum, Mayo... ¿qué es exactamente lo que tienes que mirar? El ATLAS VISUAL DE INSTRUMENTAL QUIRÚRGICO™ te da un sistema de estudio visual organizado para reconocer cada instrumento, comparar los que se parecen y entender cómo se arma cada caja y cada mesa.",
  punchline: "OBSERVA. COMPARA. RECONOCE.",
};

export const search = {
  title: "😩 DEJA DE BUSCAR EN ",
  highlight: "UN LUGAR DISTINTO",
  after: " PARA CADA TEMA",
  text: "Ya estudias instrumentación. El problema es perder tiempo saltando entre apuntes, diapositivas, videos y fotos sueltas solo para entender qué es lo que tienes en la mano. Abre el sistema, elige la familia o la especialidad y sigue las referencias visuales.",
  punchline: "MENOS BÚSQUEDA. MÁS ESTUDIO ORDENADO.",
};

export const system = {
  title: "EL SISTEMA COMPLETO DE ESTUDIO DE INSTRUMENTAL ",
  highlight: "6 EN 1",
  name: "🩺 Atlas Visual de Instrumental Quirúrgico™",
  verbs: "Reconocer • Nombrar • Comparar • Armar • Anticipar • Repasar",
  items: [
    "Instrumental básico por familias",
    "Cajas por especialidad",
    "Mesa quirúrgica paso a paso",
    "Tórax, cardiovascular y neurocirugía",
    "Urología, otorrino, oftalmología y plástica",
    "Suturas, energía y esterilización",
  ],
};

export const modules = {
  title: "QUÉ ",
  highlight: "INCLUYE",
  items: [
    {
      number: "1",
      icon: "scissors",
      label: "Módulo 1",
      title: "ATLAS DEL INSTRUMENTAL BÁSICO",
      text: "Construye una base sólida para reconocer cada instrumento. Aprende las familias de corte, hemostasia, prensión, separación, síntesis y aspiración: nombre y alias por país, para qué sirve, cómo reconocerlo y cómo diferenciarlo del que se le parece.",
      punchline: "RECONOCE. NOMBRA. DIFERENCIA.",
    },
    {
      number: "2",
      icon: "briefcase",
      label: "Módulo 2",
      title: "ATLAS VISUAL DE CAJAS POR ESPECIALIDAD",
      text: "Entiende qué trae cada caja y para qué se usa cada pieza. Recorre cirugía general, ginecología y obstetricia, traumatología y laparoscopía, con las cajas de laparotomía, cesárea, legrado y colecistectomía.",
      punchline: "UBICA. ARMA. VERIFICA.",
    },
    {
      number: "3",
      icon: "clipboard",
      label: "Módulo 3",
      title: "ATLAS DE LA MESA QUIRÚRGICA PASO A PASO",
      text: "Deja de improvisar en la mesa y aprende el orden que te permite anticiparte. Zona estéril, lavado y vestido, mesa de Mayo y auxiliar, recuento, carga del bisturí y del portaagujas, señales del cirujano y tiempos quirúrgicos.",
      punchline: "PREPARA. CUENTA. ANTICÍPATE.",
    },
    {
      number: "4",
      icon: "heart",
      label: "Módulo 4",
      title: "ATLAS DE TÓRAX, CARDIOVASCULAR Y NEUROCIRUGÍA",
      text: "Estudia el instrumental de las cirugías de alta complejidad con comparaciones visuales organizadas: separadores costales, esternótomo, clamps de Satinsky, DeBakey y bulldog, perforador y craneótomo, Kerrison, Penfield y bipolar.",
      punchline: "IDENTIFICA. COMPARA. ENTIENDE.",
    },
    {
      number: "5",
      icon: "eye",
      label: "Módulo 5",
      title: "ATLAS DE UROLOGÍA, OTORRINO, OFTALMOLOGÍA Y PLÁSTICA",
      text: "Desarrolla un enfoque ordenado para el instrumental fino de las especialidades: sondas, cistoscopio y resectoscopio, espéculos y pinzas en bayoneta, blefarostato y Castroviejo, ganchos de piel y dermatomo.",
      punchline: "OBSERVA. DISTINGUE. CUIDA.",
    },
    {
      number: "6",
      icon: "zap",
      label: "Módulo 6",
      title: "ATLAS DE SUTURAS, ENERGÍA Y ESTERILIZACIÓN",
      text: "Integra todo lo que rodea al instrumental: calibres y tipos de sutura, agujas y grapadoras, electrobisturí monopolar y bipolar, placa de retorno, ciclo del instrumental, métodos de esterilización e indicadores.",
      punchline: "LEE. ELIGE. CONTROLA.",
    },
  ],
};

export const gallery = {
  eyebrow: "MIRA POR DENTRO",
  title: "DESCUBRE QUÉ HAY DENTRO DEL ",
  highlight: "ATLAS VISUAL DE INSTRUMENTAL QUIRÚRGICO™",
  text: "Fichas con ilustración, nombres por país, páginas ¿Cuál es cuál?, cajas por especialidad, mesa paso a paso y autoevaluaciones.",
  hint: "desliza para ver cada página",
  pages: [
    {
      src: "https://imgproxy.gamma.app/resize/quality:80/resizing_type:fit/width:900/https://cdn.gamma.app/bfkgab0kedj5ug4/generated-images/xOlPCkZlWTiWAPac.jpg",
      alt: "Ficha de instrumento con ilustración, nombres por país, uso y diferencias",
    },
    {
      src: "https://imgproxy.gamma.app/resize/quality:80/resizing_type:fit/width:900/https://cdn.gamma.app/bfkgab0kedj5ug4/generated-images/1Xw7ZXC_2zhaSdr_.jpg",
      alt: "Página ¿Cuál es cuál? comparando dos instrumentos parecidos",
    },
    {
      src: "https://imgproxy.gamma.app/resize/quality:80/resizing_type:fit/width:900/https://cdn.gamma.app/bfkgab0kedj5ug4/generated-images/0dqRCidqezleXj6H.jpg",
      alt: "Página de autoevaluación del volumen",
    },
    {
      src: "https://imgproxy.gamma.app/resize/quality:80/resizing_type:fit/width:900/https://cdn.gamma.app/bfkgab0kedj5ug4/generated-images/dWywSrM8DpV30gPB.jpg",
      alt: "Página ¿Allis o Babcock?",
      caption: "Página ¿Allis o Babcock?",
    },
    {
      src: "https://imgproxy.gamma.app/resize/quality:80/resizing_type:fit/width:900/https://cdn.gamma.app/bfkgab0kedj5ug4/generated-images/uNSJrQs91c9B0eEc.jpg",
      alt: "Ficha del separador de Finochietto",
      caption: "Ficha del separador de Finochietto",
    },
  ] as { src: string; alt: string; caption?: string }[],
};

export const bonuses = {
  title: "🎁 ",
  highlight: "5 BONOS PROFESIONALES",
  after: " INCLUIDOS",
  includedLabel: "INCLUIDO GRATIS",
  items: [
    {
      label: "Bono 1",
      title: "TARJETAS DE INSTRUMENTAL PARA ESTUDIAR™",
      subtitle: "El instrumental esencial en una referencia para repasar",
      text: "Repasa en minutos 60 instrumentos con su nombre, su uso y la pista para no confundirlos.",
      punchline: "MIRA. NOMBRA. REPASA.",
    },
    {
      label: "Bono 2",
      title: "GUÍA ¿CUÁL ES CUÁL? LOS 12 PARES QUE MÁS SE CONFUNDEN™",
      subtitle: "Aprende a ver la diferencia que importa",
      text: "Compara lado a lado Kelly y Crile, Allis y Babcock, Metzenbaum y Mayo y 9 pares más, con la diferencia clave y una frase para recordarla.",
      punchline: "COMPARA. DETECTA. RECUERDA.",
    },
    {
      label: "Bono 3",
      title: "CHECKLISTS DE MESA PARA 8 CIRUGÍAS™",
      subtitle: "Marcos de revisión para las cirugías más frecuentes",
      text: "Laparotomía, apendicectomía, colecistectomía laparoscópica, cesárea, histerectomía, legrado, hernioplastia y osteosíntesis con placa.",
      punchline: "PREPARA. MARCA. EMPIEZA.",
    },
    {
      label: "Bono 4",
      title: "PLANILLAS DE RECUENTO™",
      subtitle: "El recuento ordenado, sin olvidos",
      text: "Planillas imprimibles para gasas, compresas, agujas, hojas e instrumental en los cuatro momentos del recuento.",
      punchline: "CUENTA. ANOTA. CIERRA.",
    },
    {
      label: "Bono 5",
      title: "GLOSARIO QUIRÚRGICO DE BOLSILLO™",
      subtitle: "Los términos del quirófano, explicados de forma simple",
      text: "Tiempos quirúrgicos, prefijos y sufijos de las cirugías, asepsia, posiciones del paciente, suturas e instrumental.",
      punchline: "ESCUCHA. ENTIENDE. RESPONDE.",
    },
  ],
};

export const notAnEbook = {
  title: "ESTO NO ES ",
  highlight: "OTRO EBOOK",
  after: " DE INSTRUMENTACIÓN",
  subtitle: "Es un sistema de estudio visual listo para usar.",
  items: [
    {
      icon: "stethoscope",
      title: "Referencias visuales prácticas",
      text: "Encuentra el instrumento, la caja o la familia que necesitas cuando estudias.",
    },
    {
      icon: "search",
      title: "Sistema de aprendizaje ordenado",
      text: "Pasa de reconocer el instrumento a armar la mesa y anticiparte.",
    },
    {
      icon: "zap",
      title: "6 áreas de estudio",
      text: "Instrumental básico, cajas, mesa, alta complejidad, especialidades y suturas.",
    },
    {
      icon: "refresh",
      title: "Para usar una y otra vez",
      text: "Vuelve al atlas cada vez que necesites repasar antes de una cirugía o un examen.",
    },
  ],
  punchline: "MENOS BÚSQUEDA. MENOS CONFUSIÓN. MÁS CLARIDAD VISUAL.",
};

export const offer = {
  eyebrow: "OFERTA ESPECIAL DE LANZAMIENTO",
  name: "🩺 Atlas Visual de Instrumental Quirúrgico™",
  tagline: "El sistema completo de estudio visual para instrumentación quirúrgica",
  badge: "Sistema completo 6 en 1",
  items: [
    "6 módulos completos",
    "5 bonos estratégicos",
    "Instrumental básico por familias",
    "Cajas por especialidad",
    "Mesa quirúrgica paso a paso",
    "Alta complejidad y especialidades",
    "Suturas, energía y esterilización",
  ],
  priceLead: "🔥 Consigue hoy el Atlas Visual de Instrumental Quirúrgico™",
  cta: "⚡ QUIERO ACCESO INMEDIATO",
  ctaNote: "Acceso digital inmediato",
  trust: [
    { icon: "lock", label: "Pago seguro" },
    { icon: "zap", label: "Acceso inmediato" },
    { icon: "shield", label: "Garantía 7 días" },
  ],
};

export const guarantee = {
  title: "🛡️ GARANTÍA DE ",
  highlight: "7 DÍAS",
  sealNumber: "7",
  sealLabel: "DÍAS",
  subtitle: "Tu compra está 100 % protegida",
  text: "Explora el ATLAS VISUAL DE INSTRUMENTAL QUIRÚRGICO™ durante 7 días. Accede al sistema completo de 6 módulos y a los 5 bonos. Si no es para ti, escríbenos dentro de los 7 días y te devolvemos el dinero.",
};

export const faq = {
  title: "PREGUNTAS ",
  highlight: "FRECUENTES",
  items: [
    {
      question: "¿Para quién es?",
      answer:
        "Para estudiantes de instrumentación y enfermería, instrumentadoras e instrumentadores que empiezan a trabajar, enfermería de quirófano que rota de servicio y quien se prepara para un examen o concurso.",
    },
    {
      question: "¿Es un producto físico?",
      answer:
        "No. Es un material digital en PDF: lo recibes al instante y puedes imprimirlo si quieres.",
    },
    {
      question: "¿Es un curso o una certificación?",
      answer: "No. Es un material de estudio y consulta. No otorga títulos ni certificados.",
    },
    {
      question: "¿Es otro ebook lleno de teoría?",
      answer:
        "No. Está armado con fichas visuales, comparaciones, listas y autoevaluaciones para usar mientras estudias o antes de una cirugía.",
    },
    {
      question: "¿Qué temas incluye?",
      answer:
        "Instrumental básico, cajas por especialidad, mesa quirúrgica, tórax, cardiovascular y neurocirugía, urología, otorrino, oftalmología y plástica, y suturas, energía y esterilización, más 5 bonos.",
    },
    {
      question: "¿Reemplaza la formación o el protocolo de mi hospital?",
      answer:
        "No. Es un complemento de estudio. Sigue siempre la formación académica y el protocolo de tu institución.",
    },
    {
      question: "¿Cómo lo recibo?",
      answer: "Al pagar te llega por correo el acceso a una carpeta con todos los PDF.",
    },
    {
      question: "¿En qué moneda pago?",
      answer:
        "En la moneda de tu país: el checkout te muestra el precio convertido automáticamente.",
    },
    {
      question: "¿En qué dispositivos lo puedo usar?",
      answer: "En el celular, la tablet o la computadora, y también impreso.",
    },
    {
      question: "¿Necesito experiencia previa?",
      answer: "No. Empieza desde lo básico y avanza paso a paso.",
    },
    {
      question: "¿Cuánto tiempo tengo acceso y qué pasa si no es para mí?",
      answer: "Los PDF son tuyos para siempre. Si no es para ti, tienes 7 días de garantía.",
    },
  ],
};

export const finalQuestion = {
  title: "UNA ",
  highlight: "ÚLTIMA PREGUNTA",
  question:
    "La próxima vez que el cirujano extienda la mano y te pida un instrumento... ¿sabrás al instante cuál es y cómo pasarlo?",
  text: "Deja de saltar entre recursos sueltos y de intentar memorizar el instrumental solo con texto. Abre el atlas. Elige la familia. Sigue las referencias visuales.",
  punchline: "OBSERVA. COMPARA. RECONOCE.",
  priceLead: "🔥 Consigue hoy el sistema completo",
  cta: "⚡ QUIERO EL ATLAS VISUAL DE INSTRUMENTAL QUIRÚRGICO™",
  ctaNote: "Acceso inmediato • Entrega digital 🛡️ Garantía de 7 días",
};

export const footer = {
  text: "© 2026 ATLAS VISUAL DE INSTRUMENTAL QUIRÚRGICO™ — Todos los derechos reservados. Es un recurso educativo de estudio y consulta. No reemplaza la formación académica, la capacitación práctica, el protocolo de cada institución ni el criterio profesional.",
};

// Barra fija en el celular (baja a la oferta)
export const stickyBar = {
  label: "Atlas completo",
  cta: "QUIERO EL ATLAS",
  href: "#oferta-precio",
};
